import { FileKind } from 'web';
import { NodeViewMode } from '@/enums/node-view-mode.enum';
import { UploadedAsset } from '@/types/api/assets';
import { I18N_KEYS } from '@/language/keys';
import { IndexedUploadedAsset } from '@/components/Common/ImageList/ImageList';

// CompactMediaPlayerControls height: 16px top padding + 16px scrubber + 12px gap + 24px row + 16px bottom padding.
const CONTROLS_OFFSET = 84;

export const getFileViewerControlsOffset = (
  viewMode: NodeViewMode,
  selectedFile: UploadedAsset | FileKind,
): number | undefined => {
  if (viewMode !== NodeViewMode.Single) {
    return undefined;
  }
  const isMediaWithControls = selectedFile?.type === 'video' || selectedFile?.type === 'audio';
  return isMediaWithControls ? CONTROLS_OFFSET : undefined;
};

export const getAssetsTypeTranslationKey = (assets: IndexedUploadedAsset[] | FileKind[]) => {
  if (assets.length === 0) {
    return '';
  }
  const assetsType = assets[0].type;
  switch (assetsType) {
    case 'image':
      return I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.IMAGES;
    case 'video':
      return I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.VIDEOS;
    case '3D':
      return I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.THREE_D_FILES;
    case 'audio':
      return I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.AUDIO;
    case 'text':
      return I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.TEXT;
    default:
      return '';
  }
};
